import { Uuid } from "@/domains/global/identifiers";
import { resolveSyncModelNamespacedUuid } from "@/modules/uuid/sync-models/resolveSyncModelNamespacedUuid";
import { SyncModelKind } from "@/store/sync/types";

/**
 * Generate a deterministic UUID for SpaceAccountCalendarEventSyncModel
 * based on the associated ConnectedCalendarEvent ID.
 *
 * Each ConnectedCalendarEvent should have exactly one SpaceAccountCalendarEventSyncModel.
 */
export const resolveSpaceAccountCalendarEventSyncModelUuid = ({
  connectedCalendarEventId,
}: {
  connectedCalendarEventId: Uuid;
}): Uuid => {
  return resolveSyncModelNamespacedUuid({
    modelKind: { value: SyncModelKind.SpaceAccountCalendarEvent },
    uuids: [connectedCalendarEventId],
  });
};
